
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Navbar from './Components/Reuable/Navbar/Navbar';
import Home from './Components/HomePage/Home';
import SignUp from './Components/SignUp/SignUp';
import Login from './Components/LogIn/Login';
import CreatePost from './Components/CreatePost/CreatePost';
import SinglePost from './Components/SinglePostPage/SinglePost';
import UserSettings from './Components/UserSettingsPage/UserSettings';
import UserProfilePage from './Components/UserProfilePage/UserProfilePage';
import PlatformHome from './Components/PlatformHomePage/PlatformHome';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Switch>
          <Route path="/signup">
            <SignUp />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/create-post">
            <CreatePost />
          </Route>
          <Route path="/post/:postID">
            <SinglePost />
          </Route>
          <Route path="/settings">
            <UserSettings />
          </Route>
          <Route path="/user/:userName">
            <UserProfilePage />
          </Route>
          <Route path="/platform/:platformName">
            <PlatformHome />
          </Route>
          <Route exact path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
